/**
 * 全局 ElMessage：默认显示关闭按钮，便于用户手动关掉超时/错误堆叠提示。
 * error：忽略请求取消类文案（canceled），避免移动端连点/切页红字打扰。
 * 须在应用启动尽早调用一次（main.js）。
 */
import { ElMessage } from 'element-plus'

/** Axios / AbortController 取消请求时的英文提示，非业务错误 */
function isIgnorableCanceledToastMessage(message) {
  return /^(canceled|cancelled|aborted)$/i.test(String(message ?? '').trim())
}

function messageFromOptions(options) {
  if (typeof options === 'string' || typeof options === 'number' || typeof options === 'boolean') {
    return String(options)
  }
  if (options && typeof options === 'object' && options.message != null) {
    return String(options.message)
  }
  return options == null ? '' : String(options)
}

function withClose(options) {
  if (typeof options === 'string' || typeof options === 'number' || typeof options === 'boolean') {
    return { message: String(options), showClose: true }
  }
  if (options && typeof options === 'object') {
    return { showClose: true, ...options }
  }
  return { showClose: true, message: options == null ? '' : String(options) }
}

export function installClosableElMessage() {
  if (ElMessage.__erpClosablePatched) return
  ElMessage.__erpClosablePatched = true

  ;['success', 'warning', 'info', 'error'].forEach((type) => {
    const orig = ElMessage[type].bind(ElMessage)
    ElMessage[type] = (options) => {
      if (type === 'error' && isIgnorableCanceledToastMessage(messageFromOptions(options))) {
        return { close() {} }
      }
      return orig(withClose(options))
    }
  })
}
